import MyProfile from "./MyProfile";
import Billing from "./Billing";

import styles from "./Account.module.css";
import SettingsContentsTitle from "../../../organism/Settings/SettingsContent/Common/SettingsContentsTitle";
import { useUserProfileQuery } from "../../../../react-query/user/queries";

interface AccountProps {
  onDelete: () => void;
}

export default function Account({ onDelete }: AccountProps) {
  const { data: userProfile } = useUserProfileQuery();

  return (
    <div className={styles.account__contents__area}>
      <div className={styles.account__contents}>
        <SettingsContentsTitle title="Account" />

        {userProfile != null && (
          <MyProfile
            onDelete={onDelete}
            loginData={userProfile}
          />
        )}

        <Billing />
      </div>
    </div>
  );
}
